(() => {
  if (window.__hbAtcLock) return;

  const api = {
    count: 0,
    get isLocked() {
      return this.count > 0;
    },
    increment() {
      this.count += 1;
      this.notify();
    },
    decrement() {
      this.count = Math.max(this.count - 1, 0);
      this.notify();
    },
    notify() {
      document.dispatchEvent(
        new CustomEvent("hb:atc-lock-change", {
          detail: { locked: this.count > 0 },
        }),
      );
    },
  };

  window.__hbAtcLock = api;
})();
